// extracted by mini-css-extract-plugin
module.exports = {"container":"MoreButton__container__3Er8h","menu":"MoreButton__menu__3SDHx layout__glass__1qCFi layout__rounded-top__OJPvF"};